function CategoryFilters({ categories, activeCategory, setActiveCategory }) {
  return (
    <div className="category-filters">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => setActiveCategory(category)}
          className={`filter-pill ${
            activeCategory === category ? 'active' : ''
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
}

export default CategoryFilters;
